module.exports = __webpack_public_path__ + "img/FR14879.3e184b6f.png";